<script>
import ActionConfirmationModal from './ActionConfirmationModal.vue'
import Money from '@src/mixins/money'

export default {
  mixins: [Money],
  emits: ['confirm', 'hidden'],
  components: {
    ActionConfirmationModal,
  },
  props: {
    sale: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    clientName() {
      return this.sale.client && this.sale.client.name
        ? this.sale.client.name
        : '-'
    },
    saleValue() {
      return this.sale.total != null ? this.sale.total : this.sale.amount || 0
    },
    isContract() {
      return this.sale.type === 'CONTRACT'
    },
    action() {
      return {
        title: this.isContract ? 'Cancelar Contrato' : 'Cancelar Assinatura',
        initialDescription: this.isContract
          ? 'Tem certeza que deseja cancelar este contrato?'
          : 'Tem certeza que deseja cancelar esta assinatura?',
        confirmationDescription:
          'Digite a frase abaixo para confirmar o cancelamento.',
        confirmationPhrase: this.isContract
          ? 'CANCELAR CONTRATO'
          : 'CANCELAR ASSINATURA',
        nextLabel: 'Avançar',
        confirmLabel: 'Confirmar Cancelamento',
        alert: {
          title: 'Ação Irreversível',
          description: this.isContract
            ? 'Após o cancelamento, o cliente não será mais cobrado pelas próximas parcelas, valores já pagos não serão estornados e o acesso ao conteúdo ou serviço associado poderá ser bloqueado. Certifique-se de que o cliente está ciente antes de prosseguir.'
            : 'Após o cancelamento, o cliente não será mais cobrado e perderá o acesso ao conteúdo ou serviço associado. Certifique-se de que o cliente está ciente antes de prosseguir.',
        },
      }
    },
    confirmationFields() {
      return [
        { label: 'Cliente', value: this.clientName },
        { label: 'ID da Venda', value: `#${this.sale.id || '-'}` },
        { label: 'Valor', value: `R$ ${this.formatMoney(this.saleValue)}` },
      ]
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('confirm')
    },
  },
}
</script>

<template>
  <ActionConfirmationModal
    id="cancel-subscription-modal"
    :action="action"
    :confirmation-fields="confirmationFields"
    :loading="loading"
    :error-message="errorMessage"
    @confirm="handleSubmit"
    @hidden="$emit('hidden')"
  />
</template>
